import {
  makeRequestDelete2,
  makeRequestGet,
  makeRequestGet2,
  makeRequestPost,
  makeRequestPost2,
  makeRequestPut2,
} from "../api";
import Cookies from "js-cookie";

function getToken() {
  return new Promise((resolve) => {
    const checkToken = () => {
      let token = Cookies.get("token");
      if (token) {
        resolve(token);
      } else {
        setTimeout(checkToken, 100); // Check again after 100ms
      }
    };
    checkToken();
  });
}

export async function getPromoters() {
  let token = await getToken();
  return makeRequestGet2(`promoters/`, token);
}
export async function countPromotersByOwnerId(ownerId) {
  return makeRequestGet(`promoters1/${ownerId}`,ownerId);
}
export async function getPromoter(id) {
  let token = await getToken();
  return makeRequestGet2(`promoters/${id}`, token);
}

export async function postPromoters(data) {
  let token = await getToken();
  return makeRequestPost2(`promoters/`, data, token);
}

export async function registerPromoter(data) {
  return makeRequestPost(`promoters1/register`, data);
}

export async function putPromoters(id, data) {
  let token = await getToken();
  return makeRequestPut2(`promoters/${id}`, data, token);
}

export async function deletePromoters(id, data) {
  let token = await getToken();
  return makeRequestDelete2(`promoters/${id}`, data, token);
}
